import { render } from "./ShowDetailedOrganization.vue?vue&type=template&id=299a4fa2&scoped=true"
import script from "./ShowDetailedOrganization.vue?vue&type=script&lang=js"
export * from "./ShowDetailedOrganization.vue?vue&type=script&lang=js"

import "./ShowDetailedOrganization.vue?vue&type=style&index=0&id=299a4fa2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-299a4fa2"]])

export default __exports__